//Asigno el evento "click" del botón para provoar el copiado
//document.getElementById('btnCopiar').addEventListener('click', copiarAlPortapapeles);
$("#cart-icon-bubble, #refrescapagina, .product-form__buttons").click(function(){
    $("#miniCartClone").load(location.href + " #miniCartClone");
});

//  FORMULARIO CREDITOOLS
var regex2 = /[\w-\.]{2,}@([\w-]{2,}\.)*([\w-]{2,}\.)[\w-]{2,4}/;
/* funcion form creditools */
let formCredi = $('#correoElectronico');

$('#registraCreditools').attr('disabled','disabled');

if(formCredi){
  $('.form-control' && 'input').on("keyup keydown change",function (){ 
  
      if(regex2.test($('#correoElectronico').val()?.trim()) && $('#aceptarCreditool').prop('checked') && $('#aceptarTerminosCreditools').prop('checked') && $("#nombreCompleto").val().length >= 4 && $("#nuemorCelular").val().length >= 7) {
      $('#registraCreditools').removeAttr('disabled');
      }else{
      $('#registraCreditools').attr('disabled','disabled');
      }
    });
}


$('#registraCreditools').click(function(){
  var url = "https://api.hsforms.com/submissions/v3/integration/submit/6426383/76efc14c-5a0a-4f74-bc35-b7b15af6624f/";
  var nombre = document.getElementById('nombreCompleto').value;
  var email = document.getElementById('correoElectronico').value;
  var phone = document.getElementById('nuemorCelular').value;
  //  var trabajo = document.getElementById('trabajoForm').value;
  var xhr = new XMLHttpRequest();
  xhr.open("POST", url);
  xhr.setRequestHeader("Accept", "application/json");
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
  if (xhr.readyState === 4) {
    if(xhr.status === 200){
      ShowModalResponseCreditools();
    }else{
      alert('verifique sus datos');
    }
  console.log(xhr.status);
  console.log(xhr.responseText);
  }};
  
  var list = {
  'fields' :[],
  "context":{
  "hutk": '58511f81584801d810744023f9d05683', 
  "pageUri": "https://toolstore.com.co/pages/creditools",
  "pageName": "toolstore.com.co"
  }
  };
  // guardas los datos
  list.fields.push({
    "name": "firstname",
      "value": nombre
         },{
          "name": "email",
           "value": email
         },{
          "name": "phone",
           "value": phone
         }

  );
  json = JSON.stringify(list); // ista de objetos en Json
  var obj = JSON.parse(json); //Parsea el Json al objeto anterior.
  xhr.send('' + json);
  });

  function ShowModalResponseCreditools(){
      Swal.fire({
          html: '<div id="respnseModalCreditools"><div>',
          width: 519,
          showCloseButton: true,
          showConfirmButton: false
          });
  
  
      const template = Handlebars.compile( $("#RespuestaFormCreditools").html() );
      const dataTemplate = template(); 
      $("#respnseModalCreditools").append( dataTemplate );
  } 


// FORMULARIO CREDITOOLS

// EJECUTA RMINICAR MOBILE
function correrMiniCart(){
$('#cart-icon-bubble').click( function(){
  var anchura = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  if(anchura <= 480){
    Swal.fire({
      html:'<div id="minicartMovil"></div>',
      showCloseButton: true,
      position: 'bottom',
      width: '100%',
      heightAuto: false,
      showConfirmButton: false,
      showCloseButton: true,
      showClass: {
        popup: 'animate__animated animate__slideInUp heightMinicart',
      }
    })
   // $('.swal2-popup').css("height", "100%")
    const Mcarriot = $('.refrescarMinicart').clone();
    $("#minicartMovil").append(Mcarriot);
    $('#refrescarMinicart').addClass('d-none');
  }
});
}


// FUNCION AÑADIR MODALES
$('.clickAddForm').click( () => {
  const htlm = `
      <div class="containerPayment">
          <h2 id="ts-h3" class="titulosModal">¡Estás a punto de tener tu crédito</h2>
          <p class="text-start fs-5">Deja tus datos y espera la llamada de un asesor para completar el proceso.</p>
          <form id="formADDi">
              <div class="form-group w-100">
                  <input type="text" class="form-control" id="firstname" placeholder="Nombre completo" required>
              </div>
              <div class="form-group w-100">
                  <input type="email" class="form-control" id="emailAddi" placeholder="Correo electrónico" required>
              </div>
              <div class="form-group w-100">
                  <input type="number" class="form-control" id="numberAddi" placeholder="Ingresa tú celular" required>
              </div>
              <div class="form-check w-100">
                  <input type="checkbox" class="form-check-input" id="exampleCheck1" required>
                  <label class="form-check-label laveladdi" for="exampleCheck1">Autorizo el tratamiento de mis datos personales <a href="pages/termino-y-condiciones">Ver aquí</a></label>
              </div>
              <div class="form-check w-100">
                  <input type="checkbox" class="form-check-input" id="exampleCheck2" checked>
                  <label class="form-check-label laveladdi" for="exampleCheck2">¿Quieres recibir las novedades de nuestra web?</label>
              </div>
              <button type="submit" class="btn btnSolocitud">Enviar solicitud</button>
          </form>
      </div>
  `

  Swal.fire({
      position: 'center',
      width: 450,
      html: htlm,
      showCloseButton: true,
      showConfirmButton: false
  })

  let urlApi= 'https://api-toolstore.ujueta.com/api';
  let markId ='70';
  
  $("#formADDi").submit( async (e) => {
      e.preventDefault();
      const nombre = document.getElementById('firstname').value;
      const apellido = '--';
      const email = document.getElementById('emailAddi').value;
      const countryCode = 'CO';  
      const codeHbtM = '08001'; 
      const celular = document.getElementById('numberAddi').value;
      const mensaje = 'Estoy interesado en un credito';
      const reasonId =  4; 
    
      const datosFormulario = {
        nombre,
        apellido,
        email,
        countryCode,
        codeHbtM,
        celular,
        mensaje,
        markId,
        reasonId
      };
      fetch(`${urlApi}/TrademarkForm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datosFormulario)
      })
        .then(response => {
            if(response.status === 204){
                Swal.fire({
                    confirmButtonText: 'Cerrar',
                    confirmButtonColor: 'green',
                    icon: 'success',
                    title: 'Gracias por enviar tu solicitud.',
                    text: 'Tú solicitud será atendida por uno de nustros agentes.'
                })
                setTimeout( () => {
                    window.location.reload()
                }, 1000 )
            }else if(response.status === 422){
                Swal.fire({
                    confirmButtonText: 'Cerrar',
                    confirmButtonColor: 'green',
                    icon: 'error',
                    title: 'No pudimos enviar tu correo',
                    text: 'Por favor intenta nuevamente'
                })
            }
        })
        .catch(error => {
          Swal.fire({
              confirmButtonText: 'Cerrar',
              confirmButtonColor: 'green',
              icon: 'error',
              title: 'No pudimos enviar tu correo',
              text: 'Por favor intenta nuevamente'
          })
      });
  })

});

const sendDataHubspot = async (idForm, fields) => {
  try {
      const payload = {
          'fields' : fields,
          "context":{
              "hutk": '58511f81584801d810744023f9d05683', 
              "pageUri": "https://toolstore.com.co",
              "pageName": "toolstore"
          }
      };
      const response = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/6426383/${idForm}`, {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
      });
      const resData = await response.json();
      return resData;
  } catch (error) {
      console.error(error);
      return error
  }
}
////// FIN AÑADIR MODALES ///////

const getInventaryFromSku = async (sku, region) => {
    const data  = await fetch(`https://app-online.ujueta.com/api/v1/inventory/stock_products?pais=${region ? region : 'CO' }&lstItemcode=${sku}`);
    const response = await data.json();
    return response;
};

const renderDataInventary = (data) => {
  let info = [];
  let stock = 0;
  let store= '';
  const template = Handlebars.compile($("#stock-tiendas").html());
  
  if( data.length >= 1 ){
    data.forEach( i => {
      info.push(
        {
          store: i.WhsName,
          stock: parseInt(i.STOCK),
        }
      );
    });

    const dataTemplate = template({ infoStock: info });
    //console.log("muetsras", dataTemplate)
    
    $('#stockTiendas').click(function () {
      console.log('click')
         Swal.fire({
          width: 'auto',
          html: `<div id="containerStockStore"></div>`,
          heightAuto: true,
          showConfirmButton: false,
          showDenyButton: false,
          padding: "0rem",
          //margin: "0",
          showClass: {
            popup: 'stock-tiendas'
          },
          showCloseButton: true
          });
      
          $("#containerStockStore").append( dataTemplate );
      
     });
     return info;
  }else{
    return info;
  }
}

const getSkuProduct = async () => {
  try {
    if (typeof meta.product != 'undefined'){
     
      let skuItem = meta.product.variants[0].sku;
      
      let data =  await getInventaryFromSku(skuItem);
      let total = 0;
      const {lst_bodegas, lst_distribuidores} = data;
      
      lst_bodegas.forEach( i => {
       let valor = parseFloat(i.STOCK);
       total= total + valor;
      });
      console.log("mensaje menor a 5");
        $('.mensaje-si-hay-menor-5').html(`<div class="product-form__buttons buttons-where-to-buy">
                            <div class="action-where-to-buy">
                              <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/Asesor-donde-comprarlo.png" loading="lazy" width="{{ image.width }}" height="{{ image.height }}" alt="Te ayudamos con tu compra">
                             <h3>${total > 0 ? '¡Lo tenemos en nuestras tiendas!' : '¿Te ayudamos con tu compra?'}</h3>
                              <p>${total > 0 ? 'Como el inventario varía diariamente, contacta a un asesor que te ayude con tu compra.' : 'Escríbenos y te daremos información para comprar este producto'}</p>
                              <a href="https://api.whatsapp.com/send?phone=573218149783&text=Hola%2C%20estoy%20interesado%20en%20este%20producto%20https://toolstore.com.co{{product_share_url}}" target="_blank">
                                ${total > 0 ? 'Chatear por Whatsapp' : 'Dónde comprarlo'} 
                              </a>
                            </div>
                            <div class="pre-order pre-order-new">
                              <img id="cta--add-favorite" class="cta-add--fav" src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/corazon.svg" loading="lazy" width="{{ image.width }}" height="{{ image.height }}" alt="Corazón favorito">

                              <button type="button" id="openModalPreOrder" class="btn-pre-order">
                                Avisame cuando llegue este producto
                              </button>
                            </div>`)
      $('.pickup-store-physical strong').html(`(${total})`)
      renderDataInventary(lst_bodegas)
      
    }
  } catch (error) {
    console.log('error al traer lista de bodega', error)
  }
    
};


$(".header__icon").click(function () {
  $(".container.tablet-contend .container-filtros-toolstore-mobile").addClass("z-index--f-o");
});

$("#CerrarMenuMovil").click(function () {
  $(".container.tablet-contend .container-filtros-toolstore-mobile").removeClass("z-index--f-o");
});

$(".header__icon").click(function () {
  $(".card .card__badge .container-icon--cart--heart div.cta-icon-heart-tools").addClass("z-index--f-o");
});

$("#CerrarMenuMovil").click(function () {
  $(".card .card__badge .container-icon--cart--heart div.cta-icon-heart-tools").removeClass("z-index--f-o");
});

$(".header__whatsAppMobile").click(function () {
  $(".container.tablet-contend .container-filtros-toolstore-mobile").addClass("z-index--f-o");
});

$(".close-toolstore").click(function () {
  $(".container.tablet-contend .container-filtros-toolstore-mobile").removeClass("z-index--f-o");
});

$(".mobile-facets__open").on("click", function() {
  $(".template-search .product-grid-container").css({
    "position": "relative",
    "z-index": "-1"
  });
});

$(".mobile-facets__close").on("click", function() {
  $(".template-search .product-grid-container").css({
    "position": "initial",
    "z-index": "0"
  });
});

$("#tiempoEntrega").click(function () {
    Swal.fire({
    width: 'auto',
    html: `
    <div class="tiempo-entrega-toolstore">
        <div class="container-title-time-delivery">
          <h3>Tiempos de envío</h3>
        </div>
        <div class="container-body-time-delivery">
          <ul>
            <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">
            Ofrecemos servicio de despacho a domicilio en todos nuestros productos a cualquier parte de Colombia. 
            Entregas en 1 día hábil a Barranquilla y en 3 días hábiles a Bogotá. Ciudades principales: 3-5 días hábiles. Resto del país: 10 días hábiles.</li>
            <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">Disfruta del beneficio de envío gratuito por compras a partir de $50.000.</li>
          </ul>
        </div>
    </div>`,
    heightAuto: true,
    showConfirmButton: false,
    showDenyButton: false,
    padding: "0rem",
    margin: "0",
    showClass: {
      popup: 'tiempo-entrega-toolstore'
    },
    showCloseButton: true
  });
});

$(".tempTienpoEntrega").click(function () {
  Swal.fire({
    width: 'auto',
    html: `
    <div class="tiempo-entrega-toolstore">
        <div class="container-title-time-delivery">
          <h3>Tiempos de envío</h3>
        </div>
        <div class="container-body-time-delivery">
          <ul>
            <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">
            Ofrecemos servicio de despacho a domicilio en todos nuestros productos a cualquier parte de Colombia. 
            Entregas en 1 día hábil a Barranquilla y en 3 días hábiles a Bogotá. Ciudades principales: 3-5 días hábiles. Resto del país: 10 días hábiles.</li>
            <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">Disfruta del beneficio de envío gratuito por compras a partir de $50.000.</li>
          </ul>
        </div>
    </div>`,
    heightAuto: true,
    showConfirmButton: false,
    showDenyButton: false,
    padding: "0rem",
    margin: "0",
    showClass: {
      popup: 'tiempo-entrega-toolstore'
    },
    showCloseButton: true
  });
});

$("#politicasToolstore").click(function () {
    Swal.fire({
    width: 'auto',
    html: `
    <div class="politicas-toolstore">
      <div class="container-politicas-toolstore">
        <h3>Pago contra entrega</h3>
      </div>
      <div class="container-atencion">
        <p>Lee atentamente los términos y condiciones del envío.</p>
      </div>
      <div class="container-body-politicas-toolstore">
        <ul>
          <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">Manejamos cobertura con 3 transportadoras: COORDINADORA, SERVIENTREGA Y ENVÍA.</li>
          <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">No manejan datafonos. Se despacha la factura y el cliente paga a la transportadora el valor de los productos facturados.</li>
          <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">Con COORDINADORA no se genera ningún sobre cargo por envío. Y el monto de recaudo no tiene límite.</li>
          <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">Con SERVIENTREGA y ENVIA el cliente asume un sobrecargo de 20mil pesos. Servientrega no recauda más de 2millones, la mercancía debe estar en una sola unidad de empaque y ENVIA solo recauda en efectivo.</li>
          <li><img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/icon-checkred-modal.svg">Hasta el momento no hay cobertura total es decir que no en todos lados se presta ese servicio y la lista de coberturas también puede.</li>
        </ul>
      </div>
    </div>`,
    heightAuto: false,
    showConfirmButton: false,
    showDenyButton: false,
    padding: "0rem",
    margin: "0",
    showClass: {
      popup: 'politicas-toolstore'
    },
    showCloseButton: true
  });
});

$("#showModalMercadoPago").click(function () {
  Swal.fire({
    html:
    `<div class="containerPayment">
    <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/Enmascarar_grupo_567.svg?v=1652975103" />
    <h3>Elige entre 3, 6 ó 12 cuotas.</h3>
    <p>Pagando con tarjetas de crédito de los siguientes bancos:</p>
    <img style="width: 280px;" src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/image_3.png?v=1789058672"/>
  </div>`
    ,
    showCloseButton: true,
    showConfirmButton: false,
    showClass: {
      popup: 'containerPayment'
    },
  });
});

$(".border-section-benefits:last-child").click(function () {
  Swal.fire({
    html:
    `<div class="containerBenefistToolstore">
    <h1>¡Toolstore llega a tu puerta!</h1>
    <ul>
      <li>Ofrecemos servicio de despacho a domicilio en todos nuestros productos a cualquier parte de Colombia.
      Entregas en 1 día hábil a Barranquilla y en 3 días hábiles a Bogotá. Ciudades principales: 3-5 días hábiles. Resto del país: 10 días hábiles.</li>
      <li>Disfruta del beneficio de envío gratuito por compras a partir de $50.000.</li>
    </ul>
  </div>`
    ,
    showCloseButton: true,
    showConfirmButton: false,
    showClass: {
      popup: 'containerBenefistToolstore'
    },
  });
});

$("#modalMediosPago").click(function () {
  Swal.fire({
    html:
    `<div class="tituloMediosPagos"><h1>Medios de pagos</h1></div>
    <div class="containerMediosPago">
        <div class="infoConjuntoPagos">
          <h2>Pagos con tarjetas</h2>
            <div class="pagoConTarjeta">
              <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/mercadoPagoHorizontal.svg">
                <div class="containerPagoConTarjeta">
                  <h3>Paga hasta <span>12 cuotas sin interés</span> con <strong>MERCADO PAGO</strong>, aplica para tarjetas de crédito de los siguiente bancos</h3>
                </div>
                <div class="bancosPagos">
                  <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/Bancos.png">
                </div>
                <div class="pagoDebito">
                  <h3>Débito</h3>
                  <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/debito.svg">
                </div>
                <div class="pagoCredito">
                  <h3>Crédito</h3>
                  <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/credito_d0a5bbcb-5a60-4f16-84d1-5f162f3f32e0.png">
                </div>
            </div>
        </div>
        <div class="pagoConPse">
          <div class="tituloPse">
            <h2>Pagos con</h2>
            <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/pagoPse.svg">
          </div>
          <div class="conjuntoPagoConPse">
            <h3>Paga directamente desde tu banco con tu cuenta de ahorros o corriente</h3>
            <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/conjuntopagoPse.png">
            <h3>Paga por PSE o con billeteras virtuales si la tienes activa</h3>
            <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/conjunto2Pse.png">
            <img class="logoMercadoPagoModal" src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/mercadoPagoHorizontal.svg">
            <h3>Billetera de mercadoPago: ingresa a tu cuenta de mercadopago para pagar con el dinero que tengas depositado</h3>
          </div>
        </div>
        <div class="pagoConEfectivo">
          <div class="tituloEfectivo">
            <h2>Paga con efectivo</h2>
          </div>
          <div class="conjuntoPagoEfectivo">
            <h3>Cuando termines tu compra, te daremos las instrucciones para cómo y dónde pagarla.</h3>
            <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/pagoEfectivo.png">
          </div>
        </div>
      </div>`
    ,
    showCloseButton: true,
    showConfirmButton: false,
    showClass: {
      popup: 'containerMediosPago'
    },
  });
});

$("#openModalPreOrder").click(function () {
  Swal.fire({
    html: `<form id="contactForm">
    <input type="hidden" name="form_type" value="customer">
    <input type="hidden" name="utf8" value="✓">
    <input type="hidden" name="contact[tags]" value="">
    <div id="pre-order-form" style="padding: 40px 40px 0px 40px; line-height: 21px;">
      <p style="font-size: 25px  ; color: #333E48;" class="text-center">¡Déjanos tus datos de contacto !</p>
      <p style="color: #333E48; font-size: 14px;" class="text-center">Te avísamos cuando llegue este producto</p>
      <br>
      <div class="row">
        <div class="form-group col-lg-6 col-md-12">
          <label for="name">Nombre <span class="req">*</span></label>
          <input required type="text" id="nameAvisame" class="form-control" style="border-radius: 14px !important; height: 42px !important;" name="firstname">
        </div>
        <div class="form-group col-lg-6 col-md-12">
          <label for="email">Email <span class="req">*</span></label>
          <input required="" type="email" id="emailAvisame" class="form-control" style="border-radius: 14px !important; height: 42px !important;" name="email">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-6 col-md-12">
          <label for="phone">Teléfono </label>
          <input type="text" id="phoneAvisame" class="form-control" style="border-radius: 14px !important; height: 42px !important;" name="phone">
        </div>
        <div class="form-group col-lg-6 col-md-12">
          <label for="product_name">Nombre del producto<span class="req">*</span></label>
          <input id="productNameAvisame" class="form-control" style="border-radius: 14px !important; height: 42px !important;" name="product_name" value="${window.location.href}" readonly />
        </div>
      </div> 
    </div>
      <div class="row">
        <div class="form-group col-lg-12 col-md-12 text-center mt-4">
          <input type="checkbox" name="checks" required id="checks" class="only-one">Autorización tratamiento de datos, <a href="https://toolstore.com.co/pages/termino-y-condiciones"><u>ver aquí</u></a>
        </div>
      </div>

    <input type="submit" value="Enviar">
  </form>`,
    showCloseButton: true,
    showConfirmButton: false,
    showClass: {
      popup: 'containerPreOrder'
    },
  });

  $("#contactForm").submit( async (e) => {
    e.preventDefault();
    let obj = [
        {
            name: "firstname",
            value: $("#nameAvisame").val()
        },
        {
            name: "email",
            value: $("#emailAvisame").val()
        },
        {
            name: "phone",
            value: $("#phoneAvisame").val()
        },
        {
          name: "product_name",
          value: $("#productNameAvisame").val()
        }
    ];
    const valid =  await sendDataHubspot("04afcdcf-69f5-4544-96bb-9564317e761f", obj);
    if( valid['status'] === undefined ){
      Swal.fire({
        icon: 'success',
        title: 'Formulario enviado exitosamente',
        showConfirmButton: false,
        timer: 1500
      })
    }else{
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            showConfirmButton: false,
            showDenyButton: false,
            html: `<p class="textModalError">Verifica que tus datos sean reales. Si lo son, y aún así aparece este error, puedes pedir la misma consulta a través de 
            <a href="https://api.whatsapp.com/send?phone=573218149783&text=Hola">Whatsapp</a> o 
            <a href="https://www.messenger.com/t/441296492599585/">Messenger</a>.</p>`,
            showCloseButton: true
        })
    }
  })
});


const myContainer = document.getElementById('contenido-modal-ccm');
$("#ver-instructivo").click(function () {
  Swal.fire({
      html: myContainer.innerHTML,
      title: '<div class="titulo-instructivo">Instructivo  -  como comprar</div>',
      showConfirmButton: false,
      showDenyButton: false,
      customClass: {
        container: 'margen-instructivo',
      },
      showClass: {
        popup: 'container-instructivo'
      },
      showCloseButton: true,
      willClose: () => {
        $('.owl-instructivo').trigger('destroy.owl.carousel');
      }
  });
  $(".owl-instructivo").owlCarousel({
    loop: false,
    margin: 90,
    nav: true,
    dots: true,
    items: 1,
    autoWidth: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    direction: 'up'
  });
});

$(".showPassword").on("click", function() {
  
  let passwordInput = $(".customerPassword");
  let passwordInputType = passwordInput.attr("type");
  
  if (passwordInputType === "password") {
    passwordInput.attr("type", "text");
    $(".showPassword i").removeClass('fa-eye-slash').addClass('fa-eye');
  } else {
    passwordInput.attr("type", "password");
    $(".showPassword i").removeClass('fa-eye').addClass('fa-eye-slash');
  }

});

/**
 * 
 * @param { type, message, icon} showNotification 
 */


class ProductFavorite{
  constructor(sku){
    this.sku = sku;
    this.store = localStorage.getItem("favorito");
  }

  getStore(){
    return JSON.parse(this.store)
  }
  addProduct(){
    if(this.store){
      let array = JSON.parse(this.store);
      let filtArr = array.find( i => i === this.sku );

      if(filtArr){
        //delete duplicados
        localStorage.setItem('favorito', JSON.stringify( array.filter( i => i != this.sku ) )) ;
        showNotification({ position: 'top-end', title: 'Producto eliminado de favorito', icon: 'error'  });
        return false
      }else{
        array.push(this.sku)
        localStorage.setItem('favorito', JSON.stringify( array )) ;
        showNotification({ position: 'top-end', title: 'Producto agregado a favoritos', icon: 'success'  });
        return true
      }
    }else{
      let array = [this.sku];
      localStorage.setItem('favorito', JSON.stringify(array))
      showNotification({ position: 'top-end', title: 'Producto agregado a favoritos', icon: 'success'  });
      return true
    }
  }
  deleteFavorite(){
    if(this.store){
      let currentStore = JSON.parse(this.store);
      let newArrey = currentStore.filter( i => i != this.sku );
      localStorage.setItem('favorito', JSON.stringify(newArrey))
    }
  }
}

function showNotification(props){
  const { position, title, icon} = props;
  const Toast = Swal.mixin({
    toast: true,
    position: position,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
  
  Toast.fire({
    icon: icon ? icon: 'success',
    title: title ? title : 'Signed in successfully'
  })
}

Handlebars.registerHelper('ifEquals', function (a, b, options) {
    if (a == b) { return options.fn(this); }
    return options.inverse(this);
});

Handlebars.registerHelper('ifNotEquals', function (a, b, options) {
  if (a != b) { return options.fn(this); }
  return options.inverse(this);
});

$('#cta--add-favorite').click( function(){
  let skuProduct = meta.product.variants[0].sku;
  const favorite = new ProductFavorite(skuProduct);

  let addFav = favorite.addProduct();

  if(addFav === true ){
    $("#cta--add-favorite").attr("src", "https://cdn.shopify.com/s/files/1/0274/5804/3990/files/corazon-relleno.svg");
  }else{
    $("#cta--add-favorite").attr("src", "https://cdn.shopify.com/s/files/1/0274/5804/3990/files/corazon.svg");
  }
  
})

$('.gta-favoritos-product').click( function(){
  let val = $(this).attr("product-id");

  if(val != null) {
    const favorite = new ProductFavorite(val);
    let addFav = favorite.addProduct();

    if(addFav === true ) return $(this).addClass('favProduct')
    return $(this).removeClass('favProduct')
  }
});

const validateFavoritos = () => {
  const favorite = new ProductFavorite();
  let totalStore = favorite.getStore();
  if(totalStore != null){
    $('.count_circle').html(totalStore.length).css('background-color', '#FF0000');

    totalStore.forEach(i => {
      $(`[product-id='${i}']`).addClass('favProduct');

      if( meta.product?.variants[0].sku ){
        if(meta.product.variants[0].sku === i){
          $("#cta--add-favorite").attr("src", "https://cdn.shopify.com/s/files/1/0274/5804/3990/files/corazon-relleno.svg");
        }
      }
    });
  }
};

const vendedores = [
  {
    firstName: "NELSON",
    lastName: "CORREA OSPINA",
    middleName: "ARMANDO",
    ExtEmpNo: "98573809",
    SlpCode: "3",
    SlpName: "Nelson Correa - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "DARIO",
    lastName: "FRANKY DACHIARDI",
    middleName: "ALFREDO",
    ExtEmpNo: "80119141",
    SlpCode: "1005",
    SlpName: "Dario Franky - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "ALVARO",
    lastName: "ARANGO HURTADO",
    middleName: "JOSE",
    ExtEmpNo: "NULL",
    SlpCode: "1030",
    SlpName: "Alvaro Arango - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "GIOVANNY",
    lastName: "PUENTE",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1039",
    SlpName: "Giovanny Puente - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "CALL",
    lastName: "CENTER",
    middleName: "NULL",
    ExtEmpNo: "79878271",
    SlpCode: "1040",
    SlpName: "Call Center - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JOHNATAN",
    lastName: "VILLALBA",
    middleName: "NULL",
    ExtEmpNo: "1113663096",
    SlpCode: "1172",
    SlpName: "Jonathan Villalba - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "ANA",
    lastName: "BOLAÑOS",
    middleName: "NULL",
    ExtEmpNo: "270",
    SlpCode: "1040",
    SlpName: "Call Center - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "CRISTIAN",
    lastName: "DIAZ",
    middleName: "NULL",
    ExtEmpNo: "1033729492",
    SlpCode: "1121",
    SlpName: "Publicidad - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JAVIER",
    lastName: "ARAGON PULIDO",
    middleName: "AUTOMABOG",
    ExtEmpNo: "1012444044",
    SlpCode: "16",
    SlpName: "Paloquemao - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "Monica",
    lastName: "Munoz",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1123",
    SlpName: "Monica Muñoz - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "GUILLERMO",
    lastName: "VIRGUEZ",
    middleName: "NULL",
    ExtEmpNo: "1030539517",
    SlpCode: "28",
    SlpName: "7Agosto - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "ALEXIS",
    lastName: "SANCHEZ",
    middleName: "NULL",
    ExtEmpNo: "1144125114",
    SlpCode: "1081",
    SlpName: "Alexis Sanchez - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "LEONARDO",
    lastName: "BERNATE",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1098",
    SlpName: "Leonardo Bernate - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JULIO",
    lastName: "GAMARRA",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1049",
    SlpName: "Calle 30 - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "ANGELA",
    lastName: "GAONA",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1120",
    SlpName: "Angela Gaona - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JACQUELINE",
    lastName: "VELASQUEZ",
    middleName: "NULL",
    ExtEmpNo: "1013641437",
    SlpCode: "1040",
    SlpName: "Call Center - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "COLOMBIANA",
    lastName: "DE COMERCIO",
    middleName: "NULL",
    ExtEmpNo: "80657375",
    SlpCode: "1076",
    SlpName: "Corbeta - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JOSE",
    lastName: "DAZA",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1142",
    SlpName: "Jose Luis Daza - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "LUIS",
    lastName: "ALDANA",
    middleName: "NULL",
    ExtEmpNo: "1075275481",
    SlpCode: "1150",
    SlpName: "Luis Aldana - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JOHAN",
    lastName: "VELILLA BERDUGO",
    middleName: "ENRIQUE",
    ExtEmpNo: "72357137",
    SlpCode: "1155",
    SlpName: "Johan Velilla",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "Diana",
    lastName: "Garcia Niño",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1040",
    SlpName: "Call Center - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "PRUEBA",
    lastName: "DIEGO",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1",
    SlpName: "Oscar Parra - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "CRISTHIAN",
    lastName: "DELGADO SALAZAR",
    middleName: "MANUEL",
    ExtEmpNo: "1085302764",
    SlpCode: "1159",
    SlpName: "Cristian Delgado - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "MARIO",
    lastName: "GARCIA",
    middleName: "NULL",
    ExtEmpNo: "1093213669",
    SlpCode: "1160",
    SlpName: "Mario Garcia - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "MIGUEL",
    lastName: "SARMIENTO",
    middleName: "NULL",
    ExtEmpNo: "91528090",
    SlpCode: "1168",
    SlpName: "Miguel Sarmiento - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JAIME",
    lastName: "MERCADO DUQUE",
    middleName: "ENRIQUE",
    ExtEmpNo: "72278338",
    SlpCode: "1177",
    SlpName: "Jaime Mercado - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "OMAR",
    lastName: "PARADA CHACON",
    middleName: "NULL",
    ExtEmpNo: "91474512",
    SlpCode: "1182",
    SlpName: "Omar Parada - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "ISAIAS",
    lastName: "REYES CARDENAS",
    middleName: "SEBASTIAN",
    ExtEmpNo: "1098748386",
    SlpCode: "38",
    SlpName: "San Francisco - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JOSE",
    lastName: "MARULANDA",
    middleName: "MIGUEL",
    ExtEmpNo: "1040044986",
    SlpCode: "32",
    SlpName: "Palace - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "LEIDY",
    lastName: "DIAZ CORRALES",
    middleName: "YOHANNA",
    ExtEmpNo: "1113532240",
    SlpCode: "1214",
    SlpName: "Leidy Diaz - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JAVIER",
    lastName: "ARAGON PULIDO",
    middleName: "EDUARDO",
    ExtEmpNo: "NULL",
    SlpCode: "28",
    SlpName: "7Agosto - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "BRYAN",
    lastName: "MUÑOZ",
    middleName: "NULL",
    ExtEmpNo: "1151958860",
    SlpCode: "35",
    SlpName: "CaliNorte - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "BAIRON",
    lastName: "BELTRAN",
    middleName: "NULL",
    ExtEmpNo: "NULL",
    SlpCode: "1040",
    SlpName: "Call Center - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JOSE",
    lastName: "BELLO SOTO",
    middleName: "ALBERTO",
    ExtEmpNo: "1.010.002.557",
    SlpCode: "1223",
    SlpName: "Jose Bello Soto",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JOSE",
    lastName: "PIRAQUIVE",
    middleName: "MAURICIO",
    ExtEmpNo: "79.547.189",
    SlpCode: "1224",
    SlpName: "Jose Piraquive",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "KAREN",
    lastName: "ARISTIZABAL",
    middleName: "ISABEL",
    ExtEmpNo: "NULL",
    SlpCode: "1040",
    SlpName: "Call Center - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "JUAN",
    lastName: "ARANGO",
    middleName: "JOSE",
    ExtEmpNo: "NULL",
    SlpCode: "1040",
    SlpName: "Call Center - Dist",
    Locked: "N",
    Active: "Y",
  },
  {
    firstName: "DANIEL",
    lastName: "SARMIENTO RINCON",
    middleName: "NULL",
    ExtEmpNo: "1.019.145.144",
    SlpCode: "1225",
    SlpName: "Daniel Sarmiento",
    Locked: "N",
    Active: "Y",
  },
];

const fetchData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(vendedores);
    }, 1000);
  });
};

const addToCartWithNote = (slpCode) => {
  const formData = new FormData();
  formData.append("note", slpCode);
  fetch("/cart/update.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Campo note actualizado correctamente:", data);
    })
    .catch((error) => {
      console.error("Error al actualizar campo note:", error);
    });
};

const pintarInformacionVendedor = () => {
  try {
    const vendedor = JSON.parse(localStorage.getItem("vendedor"));
    if (vendedor) {
      document.getElementById("sectionSellers").style.display = "flex";
      document.getElementById( "areaSeller").innerHTML = `<p>Tu asesor es: ${vendedor.firstName} ${vendedor.lastName}</p>`;
      document.getElementById("removeItem").addEventListener("click", () => {
        localStorage.removeItem("vendedor");
        const formData = new FormData();
        formData.append("note", "");
        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            location.reload();
          })
          .catch((error) => {
            console.error("Error al actualizar campo note:", error);
          });
      });
    }
  } catch (error) {
    console.error("Error al pintar la información del vendedor:", error);
  }
};

const obtenerYMostrarDatos = async () => {
  try {
    const url = new URL(window.location.href);
    const slpCodeFromURL = url.searchParams.get("s_id");

    if (slpCodeFromURL) {
      const rest = await fetchData();
      const vendedorEncontrado = rest.find(
        (vendedor) => vendedor.SlpCode === slpCodeFromURL
      );

      if (vendedorEncontrado) {
        localStorage.setItem("vendedor", JSON.stringify(vendedorEncontrado));
        addToCartWithNote(slpCodeFromURL);
      }
      pintarInformacionVendedor();
    } else {
      pintarInformacionVendedor();
    }
  } catch (error) {
    console.error("Error al obtener los datos:", error);
  }
};

$(document).ready(function () {
  //$(".header__inline-menu ul li:nth-last-child(2) a span").append('<span class="nuevoSmartHome">Nuevo</span>');
  $('.headerV2.sub-menu .header__inline-menu .list-menu li:nth-child(8) a span').html('Smart home <span class="nuevoSmartHome">Nuevo</span>');
  //Modificaciones menú ofertas desktop
  $('.list-menu.list-menu2 li:nth-child(2) a span.name-itemMenu2').html($('.list-menu.list-menu2 li:nth-child(2) a span.name-itemMenu2').text());
  //Modificaciones menú ofertas mobile
  $('.menu-drawer__menu li:nth-child(2) .img-promo1').addClass('img-promo2').text('Hasta 30%');
  $('.menu-drawer__menu li:nth-child(2) ul.container_sub-menu li:nth-child(2) a h3').html('<img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/combosMayo.svg" alt="Combos de mayo">');

  $('#MainContent').css("margin-bottom", "5pc");

  correrMiniCart();
  $(".apiWhatsapp").click(function(){
    apiWhatsapp()
  });

  $('.eliminarFavorito').click( function(){
    let val = $(this).attr("product-id");
    console.log(val)
  })
  
  function apiWhatsapp() {
    window.location.href = 'https://wa.me/message/O2OGPMZ63CLNC1';
  }

  // Rendimiento (2026-09): se quita la llamada getInventaryFromSku() sin SKU:
  // pedia a app-online.ujueta.com el inventario de "undefined" en TODAS las
  // paginas y la respuesta no se usaba. getSkuProduct() ya consulta el
  // inventario real, y solo en paginas de producto.
  getSkuProduct()

  validateFavoritos();
  obtenerYMostrarDatos();

  var referencePosition = 0;
  var lastPosition = 0;
  $(window).scroll(function () {
    let positionActual = $(this).scrollTop();
    if (positionActual == 0) {
      $('.background-free-shipping').removeClass("posicion-force");
    } else {
      $('.background-free-shipping').addClass("posicion-force");
      $('.background-free-shipping').addClass("active");
    }
    lastPosition = positionActual;
  });

  // Initialise Carousel HOME
  $(".owl-carousel-banner").owlCarousel({
        loop: true,
    autoplay: true,
    center: true,
    margin: 30,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    autoWidth: true,
    dots: true,
    nav: true
  });

  $(".owl-carouselCollections").owlCarousel({
    loop: true,
    autoWidth: true,
    dots: false,
    nav: true
  });

  $(".owl-collectionsCombos").owlCarousel({
    loop: true,
    autoWidth: true,
    dots: false,
    nav: true
  });

  $(".owl-collectionsLive").owlCarousel({
    loop: true,
    autoWidth: true,
    autoplay: false,
    margin: 10,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    dots: false,
    nav: true,
    infinity: false
  });

  $(".owl-carouselCollectionsCateg").owlCarousel({
    loop: true,
    dots: false,
    nav: true,
    items: 4
  });

  $(".owl-Landing-Soldadura").owlCarousel({
    loop: true,
    autoplay: true,
    center: true,
    margin: 30,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    autoWidth: true,
    dots: true,
    nav: true
  });

  // Rendimiento (2026-09, 4a pasada): sin loop, Owl no clona las tarjetas de combos
  // (con loop duplicaba todas para el giro infinito). Al llegar al final vuelve al inicio (rewind).
  $(".owl-collectionsCombosNewHome").owlCarousel({
    loop: false,
    rewind: true,
    autoWidth: true,
    dots: false,
    nav: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
  });

});

class CustomerShopify {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }
  async getCustomerByEmail(email){
    try{
        let data = await fetch(`${this.apiUrl}/shopify/search/${email}`);
        return await data.json()
    }catch(error){
      return null
    }
  }

  async create(obj){
    try {
      let data = await fetch(`${this.apiUrl}/shopify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
      });
      let res = await data.json();
      return res
    } catch (error) {
      return error
    }
  }

  async updateCustomer(obj){
    try {
      let data = await fetch(`${this.apiUrl}/shopify/customer/${obj.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
      });
      let res = await data.json();
      return res
    } catch (error) {
      return error
    }
  }
  async createRulePrice(obj){
    try {
      let data = await fetch(`${this.apiUrl}/shopify/ruleprice`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
      });
      let res = await data.json();
      return res
    } catch (error) {
      return error
    }
  }
  async  searchBonoName(name){
    try{
        let data = await fetch(`${this.apiUrl}/shopify/${name}`);
        return await data.json()
    }catch(error){
      return null
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {

  var pathName = window.location.pathname;
  
  sessionStorage.setItem("popUpEnVivo", true);
  
  if (pathName !== "/cart" && pathName !== "/pages/en-vivo-toolstore") {
  
    if (!sessionStorage.getItem("popUpEnVivo")) {
      Swal.fire({
        width: '450px',
        html: `<a class="popUpEnVivoImg" href="/pages/en-vivo-toolstore">
        <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/pop-up-_1.jpg?v=1742994209" style="width:100%;"></a>`,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: true
      });
      sessionStorage.setItem("popUpEnVivo", true);
    }
  }
  document.getElementById("Search-In-Template").blur()



          // setTimeout(function () {
  //    if (!sessionStorage.getItem("popUpCyberTools")) {
  //      Swal.fire({
  //        width: '450px',
  //        html: `<a class="popUpEnVivoImg" href="https://toolstore.com.co/pages/en-vivo-toolstore">
  //        <img src="https://cdn.shopify.com/s/files/1/0274/5804/3990/files/pop-up_8618cbc5-906f-4ad7-a950-5241b5dee77e.jpg?v=1744392554" style="width:100%;"></a>`,
  //        showConfirmButton: false,
  //        showCancelButton: false,
  //        showCloseButton: true
  //      });
  //      sessionStorage.setItem("popUpCyberTools", true);
  //    }
  //  }, 3000);
});